import { withFormik } from "formik"
import { TFunction } from "i18next"
import * as Yup from "yup"
import RemesaInitialForm from "./form"

type SubmitPaylaod = {
  empresaId: string | null
  importe: number | null
}

interface NewRemesaInitialFormProps {
  hideModal?: () => void
  handleSubmit?: (payload: SubmitPaylaod) => void
  t?: TFunction
}

interface NewRemesaInitialFormValues {
  empresaId: string | null
  importe: number | null
}

const validationSchema = (t: TFunction) =>
  Yup.object().shape({
    empresaId: Yup.string()
      .nullable()
      .required(t("remesas.edit.form.contactoRequired") ?? undefined),
    importe: Yup.number()
      .nullable()
      .required(t("remesas.edit.form.importeRequired") ?? undefined),
  })

const NewRemesaInitialForm = withFormik<
  NewRemesaInitialFormProps,
  NewRemesaInitialFormValues
>({
  validateOnChange: true,
  validateOnBlur: true,
  mapPropsToValues: () => {
    return {
      empresaId: null,
      importe: null,
    }
  },
  validationSchema: ({ t }: { t: TFunction }) => validationSchema(t),
  handleSubmit: async (values, { props }) => {
    props.handleSubmit?.(values)
  },
})(RemesaInitialForm)

export default NewRemesaInitialForm
